// extracted by mini-css-extract-plugin
export default {"boilerplate":"EmailBody_boilerplate__OWwM-","aiWriterEditorContent":"EmailBody_aiWriterEditorContent__s4msy"};